// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__1m26O","vilhempNav":"Header_vilhempNav__3lupa","facebook":"Header_facebook__1NElJ","navItem":"Header_navItem__2uTna"};